// Mixitup container
var containerEl = document.querySelector('.mixitup-container');
// Target selector
var targetSelector = '.col';
// Active hash
var activeHash = '';



/**
 * Deserializes a hash segment (if present) into in an object.
 *
 * @return {object|null}
 */
function deserializeHash() {
    var hash    = window.location.hash.replace(/^#/g, '');
    var obj     = null;
    var props  = [];

    if (!hash) return obj;

    obj = {};
    props = hash.split('&');

    props.forEach(function(props) {
        var pair = props.split('=');
        var propName = pair[0];

        obj[propName] = pair[1].split(',');
    });

    return obj;
}

/**
 * Serializes a uiState object into a string.
 *
 * @param   {object}    uiState
 * @return  {string}
 */
function serializeUiState(uiState) {
    var output = '';

    for (var key in uiState) {
        var values = uiState[key];

        if (!values.length) continue;

        output += key + '=';
        output += values.join(',');
        output += '&';
    };

    output = output.replace(/&$/g, '');

    return output;
}

/**
 * Constructs a `uiState` object using the
 * `getFilterGroupSelectors()` API method.
 *
 * @return {object}
 */
function getUiState() {
    // NB: You will need to rename the object keys to match the names of
    // your project's filter regions – these should match those defined
    // in your HTML.

	var uiState = {};

	var filterControls = $('.mixitup-filter-controls [data-filter-group]');

	$(filterControls).each(function(i, obj) {
		uiState[$(obj).attr('data-filter-group')] = mixer.getFilterGroupSelectors($(obj).attr('data-filter-group')).map(getValueFromSelector)
	});

    return uiState;
}

/**
 * Updates the URL hash whenever the current filter changes.
 *
 * @param   {mixitup.State} state
 * @return  {void}
 */
function setHash(state) {
    var selector = state.activeFilter.selector;

    // Construct an object representing the current state of each
    // filter region

    var uiState = getUiState();

    // Create a URL hash string by serializing the uiState object

    var newHash = '#' + serializeUiState(uiState);

    if (selector === targetSelector && window.location.href.indexOf('#') > -1) {
        // Equivalent to filter "all", and a hash exists, remove the hash

        activeHash = '';

        history.replaceState(null, document.title, window.location.pathname);
    } else if (newHash !== window.location.hash && selector !== targetSelector) {
        // Change the hash

        activeHash = newHash;

        history.replaceState(null, document.title, window.location.pathname + newHash);
    }
}

/**
 * Updates the mixer to a previous UI state.
 *
 * @param  {object|null}    uiState
 * @param  {boolean}        [animate]
 * @return {Promise}
 */
function syncMixerWithPreviousUiState(uiState, animate) {
	$.each(uiState, function( k, v ) {
		// Prepend '.' to each value
		for(var i=0;i<v.length;i++){
			v[i] = "." + v[i];
		}

		// Set selectors
		mixer.setFilterGroupSelectors(k, v);
	});

	$('.mixitup-filter-controls [data-filter-group] select').formSelect();

    // Parse the filter regions (passing `false` will perform no animation)
    return mixer.parseFilterGroups(animate ? true : false);
}

/**
 * Converts a selector (e.g. '.green') into a simple value (e.g. 'green').
 *
 * @param   {string} selector
 * @return  {string}
 */
function getValueFromSelector(selector) {
    return selector.replace(/\./g, '');
}

/**
 * Converts a simple value (e.g. 'green') into a selector (e.g. '.green').
 *
 * @param   {string} selector
 * @return  {string}
 */
function getSelectorFromValue(value) {
    return '.' + value;
}
// Initialize Mixitup
var mixer = mixitup(containerEl, {
    multifilter: {
        enable: true,
        logicBetweenGroups:'and'
    },
	selectors:{
            target:'[data-ref="mixitup-target"]'
    },
    controls:{
        toggleDefault:'all'
    },
    animation: {
        duration:500,
        effects: 'fade translateZ(100px)',
        reverseOut:true,
        nudge:false,
        easing:'ease-in-out',
    },
    callbacks: {
        onMixEnd: setHash // Call the setHash() method at the end of each operation
    }
});
// UI state from hash
var uiStateFromHash = deserializeHash();

// If a valid uiState object is present on page load, filter the mixer
if (uiStateFromHash) {
    syncMixerWithPreviousUiState(uiStateFromHash);
}

$(function () {
    // Scroll back to top of grid if pager is clicked
    $(document).on('click', 'button.mixitup-control', function () {
        $('html,body').animate({
            scrollTop: $("div.mixitup-container").offset().top - 100
        }, 'slow');
    });
});
